import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type LayoutState = {
  boardView: 'board' | 'list'
  diffStyle: 'split' | 'unified'
  terminalReadOnly: boolean
  sidebarWidth: number
  setBoardView: (v: 'board' | 'list') => void
  setDiffStyle: (v: 'split' | 'unified') => void
  setTerminalReadOnly: (v: boolean) => void
  setSidebarWidth: (w: number) => void
  sessionsWidth: number
  setSessionsWidth: (w: number) => void
  /** The main sidebar while a session is open: folded away unless asked for. */
  navInSession: boolean
  setNavInSession: (v: boolean) => void
}

/** Pane and view preferences; persisted, never sent to the server. */
export const useLayout = create<LayoutState>()(
  persist(
    (set) => ({
      boardView: 'board',
      diffStyle: 'split',
      terminalReadOnly: false,
      sidebarWidth: 240,
      setBoardView: (boardView) => set({ boardView }),
      setDiffStyle: (diffStyle) => set({ diffStyle }),
      setTerminalReadOnly: (terminalReadOnly) => set({ terminalReadOnly }),
      setSidebarWidth: (w) => set({ sidebarWidth: Math.round(Math.min(480, Math.max(180, w))) }),
      sessionsWidth: 256,
      setSessionsWidth: (w) => set({ sessionsWidth: Math.round(Math.min(480, Math.max(160, w))) }),
      navInSession: false,
      setNavInSession: (navInSession) => set({ navInSession }),
    }),
    { name: 'trisof.layout' },
  ),
)
